module.exports = __webpack_public_path__ + "img/Tommy Hanes.e2e7beb6.jpg";